import React from 'react';
import MkPlanTable from '../MkPlanTable';

const ROWS = [
  { feature: 'Apps you can pause', free: 'Up to 3', premium: 'Unlimited' },
  { feature: 'Pause types', free: '3', premium: 'All 7' },
  { feature: 'Adult-content blocking', free: true, premium: true },
  { feature: 'Your own blocked sites and strict mode', free: false, premium: true },
  { feature: 'Hard Block timed focus sessions (Android)', free: true, premium: true },
  { feature: 'Per-app Hard Block and "until off" sessions (Android)', free: false, premium: true },
  { feature: 'History, heatmap and insights', free: 'Streak and today', premium: true },
  { feature: 'Mindful-break reminders', free: false, premium: true },
];

// B8 — which blocking is free and which is Premium. No prices, no CTA.
const BmbPlans = () => (
  <section className="mk-plans section" id="plans" aria-labelledby="mk-plans-title">
    <div className="container-sm">
      <div className="section-inner">
        <div className="mk-card mk-planpanel mk-planpanel--bmb reveal-from-bottom">
          <h2 id="mk-plans-title" className="mk-h2 mk-h2--sm">
            Free and Premium
          </h2>
          <MkPlanTable caption="Bring Me Back free and Premium features" rows={ROWS} />
          <p className="mk-micro mk-planpanel__note">
            Bring Me Back is free to download. Premium is an optional in-app purchase, separate from Keep Me Out Premium.
            Prices are shown in the app and on each store.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default BmbPlans;
